import React from 'react';

const PricingPolicyPage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Sayfa Başlığı ve Giriş Bölümü */}
                <header className="text-center mb-12 md:mb-16">
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Fiyatlandırma Politikası
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Mekânname'nin sunduğu ücretli hizmetler ve aboneliklerle ilgili politikalarımızı aşağıda bulabilirsiniz.
                    </p>
                </header>

                {/* İçerik Bölümleri */}
                <main className="space-y-8">
                    {/* Ücretlendirme */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            1. Ücretlendirme
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Mekânname, farklı ihtiyaçlara yönelik çeşitli abonelik planları sunar. Güncel fiyatlandırma bilgileri "Fiyatlandırma" sayfasında yer almaktadır. Tüm fiyatlar KDV hariç olup, ödeme sırasında güncel vergiler eklenebilir.
                        </p>
                    </section>

                    {/* Ödeme Koşulları */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            2. Ödeme Koşulları
                        </h2>
                        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                            <li>
                                <span className="font-semibold text-white">Ödeme Yöntemleri:</span> Kredi kartı, banka kartı ve diğer online ödeme yöntemlerini kabul ediyoruz. Ödemeler güvenli bir şekilde üçüncü taraf ödeme sağlayıcıları aracılığıyla işlenir.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Fatura:</span> Her ödeme işlemi sonrası, kayıtlı e-posta adresinize bir fatura gönderilir. Fatura bilgilerinizi profilinizden güncelleyebilirsiniz.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Abonelik Yenileme:</span> Abonelikler, aksi belirtilmedikçe otomatik olarak yenilenir. Otomatik yenilemeyi istediğiniz zaman abonelik ayarlarınızdan iptal edebilirsiniz.
                            </li>
                        </ul>
                    </section>
                    
                    {/* İptal ve İade Politikası */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            3. İptal ve İade Politikası
                        </h2>
                        <p className="text-gray-300 leading-relaxed mb-4">
                            Aboneliğinizi istediğiniz zaman iptal edebilirsiniz. İptal işleminden sonra mevcut faturalandırma dönemi sonuna kadar hizmetlerden faydalanmaya devam edebilirsiniz.
                        </p>
                        <p className="text-gray-300 leading-relaxed">
                            Mekânname, ödemesi yapılmış abonelikler için iade yapmamaktadır. Hizmetimizle ilgili bir sorun yaşamanız durumunda lütfen destek ekibimizle iletişime geçin.
                        </p>
                    </section>

                    {/* Politika Değişiklikleri */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            4. Politika Değişiklikleri
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Bu fiyatlandırma politikası, herhangi bir zamanda önceden bildirimde bulunulmaksızın değiştirilebilir. Değişiklikler, web sitemizde yayınlandığı anda yürürlüğe girer.
                        </p>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default PricingPolicyPage;
